
const initialState = {};

export function updateJourneyServices(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_JOURNEY_SERVICES.SUCCESS':
      return {
        ...state,
        journey:  action.journey.body
      };
    default:
      return state
  }
}

export function updateJourneyReception(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_JOURNEY_RECEPTION.SUCCESS':
      return {
        ...state,
        journey:  action.journey.body
      };
    default:
      return state
  }
}

export function updateJourneyMobility(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_JOURNEY_MOBILITY.SUCCESS':
      return {
        ...state,
        journey:  action.journey.body
      };
    default:
      return state
  }
}
